import { N06 } from "./N06";
import { N07 } from "./N07";
import { N08 } from "./N08";
import { N09 } from "./N09";
import { N10 } from "./N10";

export const CoverageReport = {
  sections: [ 
    N09, 
    N10,
    N06, 
    // N07, 
    // N08, 
  ],
};
